if (process.env.NODE_ENV === 'production') {
  module.exports = require('./baseUrl.prod');
} else {
  module.exports = require('./baseUrl.dev');
}
